import './App.css';

function App() {
  return (
    <div className="App">
      <iframe
        src="https://spin-win-kenya.vercel.app"
        style={{
          width: '100vw',
          height: '100vh',
          border: 'none',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0
        }}
        title="Spin WinPesa"
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
      />
    </div>
  );
}

export default App;
